import _defineProperty from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/kamaleddin/apps/coolpic-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "children", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite/ThemeContext';
import { useAccordionContext } from './AccordionPanelContext';
export var AccordionTitle = function AccordionTitle(_ref) {
  var _ref$as = _ref.as,
    Heading = _ref$as === void 0 ? 'h2' : _ref$as,
    children = _ref.children,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useAccordionContext = useAccordionContext(),
    ArrowIcon = _useAccordionContext.arrowIcon,
    flush = _useAccordionContext.flush,
    isOpen = _useAccordionContext.isOpen,
    setOpen = _useAccordionContext.setOpen;
  var theme = useTheme().theme.accordion.title;
  var onClick = function onClick() {
    return typeof setOpen !== 'undefined' && setOpen();
  };
  return _jsxs("button", _objectSpread(_objectSpread({
    className: classNames(theme.base, theme.flush[flush ? 'on' : 'off'], theme.open[isOpen ? 'on' : 'off'], className),
    onClick: onClick,
    type: "button"
  }, props), {}, {
    children: [_jsx(Heading, {
      className: theme.heading,
      "data-testid": "flowbite-accordion-heading",
      children: children
    }), ArrowIcon && _jsx(ArrowIcon, {
      "aria-hidden": true,
      className: classNames(theme.arrow.base, theme.arrow.open[isOpen ? 'on' : 'off']),
      "data-testid": "flowbite-accordion-arrow"
    })]
  }));
};